import { useClient } from '../../context/ClientContext';

const WHATSAPP_GREEN = '#25D366';

// Botón flotante de acceso rápido a WhatsApp, visible en todo el storefront
// cuando la tienda tiene un número configurado (config.contact.whatsapp).
export const FloatingWhatsApp = () => {
  const { config, uiConfig } = useClient();
  const whatsapp = config?.contact?.whatsapp;
  // El toggle vive en uiConfig.floatingWhatsapp (templates 1-3) o uiConfig.t4.floatingWhatsapp (template 4)
  const enabled = (uiConfig?.floatingWhatsapp?.enabled ?? uiConfig?.t4?.floatingWhatsapp?.enabled) !== false;

  if (!whatsapp || !enabled) return null;

  const phone = whatsapp.replace(/\D/g, '');
  const message = `Hola! Quería hacer una consulta sobre ${config?.displayName || config?.name || 'la tienda'}.`;
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: WHATSAPP_GREEN,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        zIndex: 1000,
        transition: 'transform 0.2s ease',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.08)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
    >
      <i className="bi bi-whatsapp" style={{ color: '#fff', fontSize: 28 }} />
    </a>
  );
};
